/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InboundDocument } from './InboundDocument';
import {
    InboundDocumentFromJSON,
    InboundDocumentFromJSONTyped,
    InboundDocumentToJSON,
    InboundDocumentToJSONTyped,
} from './InboundDocument';

/**
 * 
 * @export
 * @interface UpdateInboundDocument200Response
 */
export interface UpdateInboundDocument200Response {
    /**
     * 
     */
    data?: InboundDocument;
}

/**
 * Check if a given object implements the UpdateInboundDocument200Response interface.
 */
export function instanceOfUpdateInboundDocument200Response(value: object): value is UpdateInboundDocument200Response {
    return true;
}

export function UpdateInboundDocument200ResponseFromJSON(json: any): UpdateInboundDocument200Response {
    return UpdateInboundDocument200ResponseFromJSONTyped(json, false);
}

export function UpdateInboundDocument200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInboundDocument200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : InboundDocumentFromJSON(json['data']),
    };
}

export function UpdateInboundDocument200ResponseToJSON(json: any): UpdateInboundDocument200Response {
    return UpdateInboundDocument200ResponseToJSONTyped(json, false);
}

export function UpdateInboundDocument200ResponseToJSONTyped(value?: UpdateInboundDocument200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': InboundDocumentToJSON(value['data']),
    };
}

